export const environment = {
  production: true,
  // serverUrl:'https://api.mazayaoffers.ae/api',
  //  nodeServerReportUrl: 'https://reports.mazayaoffers.ae/api/v1',
   // nodeServerUrl: 'https://vouchers.mazayaoffers.ae/api/v1',

  serverUrl: 'https://mazaya-api.gewaninfotech.com/api',
  nodeServerReportUrl: 'https://mazaya-reports.gewaninfotech.com/api/v1',
  nodeServerUrl: 'https://mazayabackendapi.gewaninfotech.com/api/v1',

  socketUrl: 'https://mazayabackendapi.gewaninfotech.com',
  clientUrl: 'https://mazaya-api.gewaninfotech.com',
  useSSO: false,
  instrumentationKey: null,
  defaultLanguage: 'en-US',
};

